/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicMetricValueStorage extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicMetricValueStorage");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicMetricValueStorage.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicMetricValueStorage>): BackgroundJobPayloadForPeriodicMetricValueStorage {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicMetricValueStorage(), model);
        BackgroundJobPayloadForPeriodicMetricValueStorage.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicMetricValueStorage>): BackgroundJobPayloadForPeriodicMetricValueStorage {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicMetricValueStorage.newInstance(<BackgroundJobPayloadForPeriodicMetricValueStorage> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicMetricValueStorage) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicMetricValueStorage.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicMetricValueStorage): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicMetricValueStorage.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
